import { UPDATE_PRODUCT } from '../actions/productActions'
import {
  getPartnershipAndConventionFromRawValue,
  getFlowRawValue
} from '../../utils'

/**
 * Product reducer
 * @module  {Reducer} productReducer
 *
 * @param {Object} state      The current state
 * @param {Object} action     The action
 * @return {Object}           The new state
 */
export default (state = {}, action) => {
  switch (action.type) {
    case UPDATE_PRODUCT:
      const pAndC = getPartnershipAndConventionFromRawValue(action.flow)
      return {
        ...state,
        ...action.product,
        ...pAndC,
        flow: getFlowRawValue(
          action.product.properties[action.product.prodCode].partnership ||
            pAndC.partnership,
          action.product.properties[action.product.prodCode].convenzione ||
            pAndC.convention
        ),
        ...action.product.properties[action.product.prodCode],
        properties: undefined
      }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./state/reducers/productReducer.js